import { AdaptError } from "@common/lib/error-handler/adapt-error";

export class PermissionError extends AdaptError {
    public constructor(message?: string, private shouldLog = true) {
        super(message);

        // Manually set the prototype so we get the correct instanceof behaviour as documented in
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, new.target.prototype);
    }

    public get shouldBeLogged() {
        return this.shouldLog;
    }
}
